import { SHORTCUT_PAGE_INFO_FIELDS } from '@@partner:graphql/shortcuts'
import type { DeliverySlot } from '@@partner:types:app'
import type {
  CommonSort,
  NestedFilter,
  CommonPager,
  PageInfo
} from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'


export interface FetchAllSlots {
  allSlots: {
    edges: DeliverySlot[]
    pageInfo: PageInfo
  }
}

export interface FetchAllSlotsVariables {
  filter?: NestedFilter
  sort?: CommonSort
  pager: CommonPager
}

export const GQL_QUERY_ALL_SLOTS = gql`
  query(
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    allSlots(
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
      edges {
        id
        shop_id
        shop {
          id
          name
          address
        }
        zone_id
        deliveryZone {
          id
          name
        }
        slotDate
        slotTime
        period {
          from
          to
        }
        availableUntil
        position_capacity
        positions_count
        orders_capacity
        orders_count
        timeout
      }
    }
  }
`

export const useQueryAllSlots = (variables: FetchAllSlotsVariables) => {
  const { data, loading, error, refetch, fetchMore } = useQuery<FetchAllSlots, FetchAllSlotsVariables>(
    GQL_QUERY_ALL_SLOTS,
    {
      variables,
      fetchPolicy: 'cache-and-network'
    }
  )

  const slots = data?.allSlots.edges ?? []
  const pageInfo = data?.allSlots.pageInfo

  return {
    slots,
    pageInfo,
    data,
    loading,
    error,
    refetch,
    fetchMore
  }
}